import React, { ReactElement, useEffect } from 'react';

import {
  Container,
  Grid,
  GridItem,
  Heading,
  Hr,
  Paragraph,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import PageHeading from 'components/pageHeading/PageHeading';
import StyledBox from 'components/style/styledBox/StyledBox';

import { ThankYouContent } from './ThankYouContent';
import { JOURNEY_STEPS } from '../../constants/analytics.constants';
import * as Analytics from '../../utils/analytics';
import { StyledImage } from '../fullSignatoryPage/FullSignatoryPage.styled';

function ThankYou(): ReactElement {
  const { thankYouContent } = useContent<ThankYouContent>();
  useEffect(() => {
    Analytics.setPageLoadEvent(JOURNEY_STEPS.ONLINE_REGISTRATION.THANK_YOU);
  }, []);

  return (
    <Container padding="none">
      {thankYouContent &&
        thankYouContent.map(
          ({
            serviceName,
            imageSrc,
            imageAltText,
            thankYou,
            nextSteps,
            gotYourRequest,
            finalChecks,
          }) => (
            <React.Fragment key="content">
              <PageHeading serviceName={serviceName} />
              <Grid alignX="center" alignY="top">
                <GridItem sm={12} md={8}>
                  <StyledBox>
                    <Container marginTop="05">
                      <StyledImage alt={imageAltText} src={imageSrc} />
                    </Container>
                    <Heading size="s5" marginTop="04" align="center">
                      {thankYou}
                    </Heading>
                    <Hr />
                    <Heading size="s4" align="left">
                      {nextSteps}
                    </Heading>
                    <Paragraph>{gotYourRequest}</Paragraph>
                    <Paragraph>{finalChecks}</Paragraph>
                  </StyledBox>
                </GridItem>
              </Grid>
            </React.Fragment>
          ),
        )}
    </Container>
  );
}

export default ThankYou;
